<template v-slot:default="{ isActive }">
  <v-dialog
    v-model="dialog"
    width="60rem"
    class="layer-popup"
    scrollable
  >
    <v-card>
      <!--content-->
      <v-card-title class="d-flex justify-space-between align-center">
        <div class="pop-title">{{t('message.viewDetails')}}</div>
        <v-btn
          icon="mdi-close"
          variant="text"
          @click.stop="dialog = false"
        ></v-btn>
      </v-card-title>

      <v-divider class="mb-4"></v-divider>
      <!--content-->
      <v-card-text>
        <div class="cont-group">
          <div class="top">
            <div class="txt-update" v-if="item.type=='1'">update : {{ item.modDateFormat }}</div>
            <div class="txt-group">
              <div class="txt">{{ item.memberName?item.memberName:t('message.noInfo') }} / {{ item.deptName?item.deptName:t('message.noInfo') }} / {{ item.posName?item.posName:t('message.noInfo') }}</div>
              <div class="txt2">{{ item.regDateFormat }}</div>
            </div>
            <div class="btn-group">
              <div class="radio-group2 ty01" v-if="item.type=='1'">
                <v-radio-group v-model="item.status" @change="onChangeStatus" :disabled="!isTargetButtonAble()" v-if="item.actionYn === 'Y'">
                  <v-radio :label="t('message.inProgress')" value="2"></v-radio>
                  <v-radio :label="t('message.onHold')" value="3"></v-radio>
                  <v-radio :label="t('message.complete')" value="4"></v-radio>
                </v-radio-group>
              </div>
            </div>
          </div>
          <ul class="list-group">
            <li v-if="item.type=='1'">
              <div class="tit">{{t('message.behavior')}}</div>
              <div class="txt">{{ item.behaviorTitle }}</div>
            </li>
            <li v-if="item.type=='1'">
              <div class="tit">{{t('message.location')}}</div>
              <div class="txt">{{ item.placeName }}</div>
            </li>
            <li>
              <div class="tit">{{item.type=='1'?t('message.specificSituation'):t('message.praiseReason')}}</div>
              <div class="txt">{{ item.situation }}</div>
            </li>
            <li v-if="item.type=='1'">
              <div class="tit">{{t('message.cause')}}</div>
              <div class="txt">{{ item.cause }}</div>
            </li>
            <li v-if="item.type=='1'">
              <div class="tit">{{t('message.correctiveActionDetails')}}</div>
              <div class="txt">{{ item.action }}</div>
            </li>
            <li>
              <div class="tit">{{item.type=='1'?t('message.correctiveActionTarget'):t('message.praiseTarget')}}</div>
              <div class="txt">{{ item.targetText }}</div>
            </li>
            <li v-if="item.actionYn=='Y'">
              <div class="tit">{{t('message.actionDeadline')}}</div>
              <div class="txt">{{ item.goalDate }}</div>
            </li>
            <li v-if="item.type=='1'">
              <div class="tit">{{t('message.progressStatus')}}</div>
              <div class="txt2 c01">{{ item.statusText }}</div>
            </li>
          </ul>
          <div class="img-group">
            <div class="item"
                 v-for="(item2,i2) in item.timelineImages"
                 :key="i2">
              <v-btn @click="onClickPreview(utils.getBaseUrl('timeline', item2.filePath))">
                <img :src="utils.getBaseUrl('timeline', item2.filePath)">
              </v-btn>
            </div>
          </div>
          <div class="top">
            <div class="btn-group02">
              <c-btn02 :btnText="t('message.delete')" class="ty02" @click="dialogActionDeleteModel=true" v-if="isMyBoard()"/>
              <c-btn02 :btnText="t('message.changeTarget2')" class="ty02" @click="() => { if (isTargetButtonAble()) onClickTarget() }" :disabled="!isTargetButtonAble()"  v-if="item.actionYn === 'Y'"/>
            </div>
          </div>
        </div>
        <InputComment :idx="item.idx" @confirmComment="confirmComment"/>
        <div class="comment-group">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-title>{{t('message.comments')}}({{item.timelineComments?item.timelineComments.length:'0'}}{{t('message.count')}})</v-expansion-panel-title>
              <v-expansion-panel-text>
                <div class="box"
                     v-for="(comment,i) in item.timelineComments"
                     :key="i">
                  <v-btn
                    icon="mdi-close"
                    variant="text"
                    class="btn-del"
                    v-if="comment.memberIdx==user.memberIdx"
                    @click="onClickDeleteComment(comment)"
                  ></v-btn>
                  <div class="txt-group">
                    <div class="txt">{{ comment.memberName?comment.memberName:t('message.noInfo') }} / {{ comment.deptName?comment.deptName:t('message.noInfo') }} / {{ comment.posName?comment.posName:t('message.noInfo') }}</div>
                    <div class="txt2">{{ comment.regDateFormat }}</div>
                  </div>
                  <div class="txt-group2">
                    <div class="txt">{{ comment.comment }}</div>
                    <div class="img-group" v-if="comment.filePath">
                      <div class="item">
                        <v-btn @click="onClickPreview(utils.getBaseUrl('comment', comment.filePath))">
                          <img :src="utils.getBaseUrl('comment', comment.filePath)">
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </div>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-card-text>
      <!--버튼-->
      <v-card-actions class=" d-flex justify-end pop-bottom-bg" v-if="false">
        <c-btn01 :btnText="t('message.confirm')" />
      </v-card-actions>
    </v-card>
    <DialogImgView v-model="previewDialogModel" @close="previewDialogModel=false" :src="previewSrc"/>
    <DialogTargetAdd4 v-model="targetDialogModel" @close="targetDialogModel=false" @confirm="confirmTarget"/>
    <DialogReason v-model="delayDialogModel" @close="delayDialogModel=false" @confirm="confirmDelay"/>
    <DialogActionComplete v-model="actionCompleteDialogModel" @close="actionCompleteDialogModel=false" @confirm="confirmActionComplete"/>
    <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
    <c-dialog v-model="dialogActionDeleteModel"
      v-bind="dialogActionDeleteBind"
      @close="dialogActionDeleteModel=false"
      @confirm="confirmDelete"
    />
    <c-dialog
      v-model="dialogActionCompleteModel"
      v-bind="dialogActionCompleteBind"
      @close="dialogActionCompleteModel=false"
      @confirm="confirmComplete"
    />
  </v-dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import TimelineService from "@/services/timeline.service";
import utils from "@/common/Utils";
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import _ from 'lodash';
import dayjs from "dayjs";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const emit = defineEmits(['close', 'delete'])

const dialog = defineModel()

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//bind
const snackbar = ref(false)
const snackText = ref('')
const previewDialogModel = ref(false)
const targetDialogModel = ref(false)
const item:any = ref({})
const previewSrc = ref('')
const user:any = ref('')
const prevStatus = ref(0)
const delayDialogModel = ref(false)
const actionCompleteDialogModel = ref(false)
const dialogActionDeleteModel = ref(false)
const dialogActionCompleteModel = ref(false)
const popupIdx = ref('')

//ui
const dialogActionDeleteBind = {
  dialogTit: t('message.delete'),
  dialogText: t('message.deleteConfirmation'),
  btn1Text: t('message.confirm'),
  btn1Show: true,
}

const dialogActionCompleteBind = {
  dialogTit: t('message.update'),
  dialogText: t('message.confirmCompleteIrreversible'),
  btn1Text: t('message.confirm'),
  btn1Show: true,
}

//watch
watch(dialog, (newObj) => {
  if(dialog.value) {
    popupIdx.value = storeRef.popupIdx.value
    onClickSearch()
  }
})

//hook
onMounted(() => {
  user.value = JSON.parse(localStorage.getItem('user'))
})

//function
const isTargetButtonAble=()=>{
  const user = JSON.parse(localStorage.getItem('user'))
  return ( (item.value.memberIdx == user.memberIdx)  //본인글 이거나
      || (item.value.targetMemberIdx == user.memberIdx && item.value.targetType == '3')  //본인타겟 이거나
      || (item.value.targetDeptIdx == user.deptIdx && item.value.targetType == '2') //본인부서 이거나
      || user.headYn == 'Y') //조직장 이거나
    && item.value.status != '4'  // 완료 아니고
}

function onClickSearch(){
  let params = {
    idx:popupIdx.value
  }

  TimelineService.getTimelineList(params).then(
    (response) => {
      //타임라인
      if(response.result.length > 0)
        item.value = response.result[0]
      item.value.typeText = item.value.type=='1'?t('message.correctiveSafety Talk'):t('message.supportiveSafetyTalk')
      item.value.actionYnText = item.value.actionYn=='Y'?t('message.necessary'):t('message.notNecessary')
      item.value.targetText = t('message.none')
      if(item.value.targetType == '2') item.value.targetText = item.value.targetDeptName
      else if(item.value.targetType == '3') item.value.targetText = item.value.targetMemberName
      item.value.goalDate = dayjs(item.value.goalDate).format('YYYY-MM-DD') == 'Invalid Date' ? '':dayjs(item.value.goalDate).format('YYYY-MM-DD')
      item.value.statusText = t('message.ready')
      if(item.value.status == '2')
        item.value.statusText = t('message.inProgress')
      else if(item.value.status == '3')
        item.value.statusText = t('message.onHold')
      else if(item.value.status == '4')
        item.value.statusText = t('message.complete')
      prevStatus.value = item.value.status
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

function onClickPreview(item){
  previewSrc.value = item
  previewDialogModel.value = true
}

function onChangeStatus(){
  if(prevStatus.value == item.value.status)
    return

  //딜레이팝업
  if(item.value.status == '3'){
    item.value.status = prevStatus.value
    delayDialogModel.value = true
    return
  } //완료처리 시 경고메시지
  else if(item.value.status == '4'){
    //시정조치 필요한 케이스면 추가정보 필요함
    if(item.value.actionYn == 'Y' && item.value.type == '1'){
      /*
      storeRef.timelineIdx.value = item.value.idx
      item.value.status = prevStatus.value
      actionCompleteDialogModel.value = true
       */
      item.value.status = prevStatus.value
      dialogActionCompleteModel.value = true
      return
    }
    else {  //그 외는 알람메시지 노출 후 변경
      item.value.status = prevStatus.value
      dialogActionCompleteModel.value = true
      return
    }
  }
  else {  //그외는 바로 변경
    item.value.targetType = null
    item.value.targetDeptIdx = 0
    item.value.targetMemberIdx = 0
    item.value.changeType = '3'
    changeStatus('')
  }
}

//딜레이팝업 컨펌
const confirmDelay=(params)=>{
  item.value.status = '3' //딜레이
  item.value.changeType = '3' //상태변경
  item.value.targetType = null
  item.value.targetDeptIdx = 0
  item.value.targetMemberIdx = 0
  changeStatus(params)
}

//완료변경
const confirmComplete=(params)=>{
  item.value.status = '4' //완료
  item.value.changeType = '3'  //상태변경
  item.value.targetType = null
  item.value.targetDeptIdx = 0
  item.value.targetMemberIdx = 0
  changeStatus(params)
}

//시정조치완료 컨펌 -> 완료처리
const confirmActionComplete=(params)=>{
  item.value.status = '4' //완료
  item.value.changeType = '3'  //상태변경
  item.value.targetType = null
  item.value.targetDeptIdx = 0
  item.value.targetMemberIdx = 0
  changeStatus(params)
}

const onClickTarget=()=>{
  if(item.value.status == '4')
    return

  const user = JSON.parse(localStorage.getItem('user'))
  if(item.value.memberIdx==user.memberIdx || item.value.targetMemberIdx==user.memberIdx || 'Y' == user.headYn) {
    storeRef.popupType.value = item.value.targetType
    //2부서 3개인
    storeRef.popupIdx.value = item.value.targetType == '3' ? item.value.targetMemberIdx : item.value.targetDeptIdx
    targetDialogModel.value = true
  }
}

const changeStatus=(delayReason)=>{
  let params = {
    idx:popupIdx.value,
    status:item.value.status,
    changeType:item.value.changeType,
    delayReason:delayReason,
    targetType:item.value.targetType,
    targetMemberIdx:item.value.targetMemberIdx,
    targetDeptIdx:item.value.targetDeptIdx,
  }

  TimelineService.updateTimeline(params).then(
    (response) => {
      prevStatus.value = item.value.status
      delayDialogModel.value=false
      onClickSearch()
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

function confirmComment(params){
  item.value.timelineComments.unshift(params)
}

function onClickDeleteComment(comment){
  let params = {
    idx:comment.idx
  }

  TimelineService.deleteTimelineComment(params).then(
    (response) => {
      if(response.success) {
        item.value.timelineComments = _.pull(item.value.timelineComments, comment)
        snackText.value = '삭제되었습니다'
        snackbar.value = true
      }
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const isMyBoard=()=>{
  const user = JSON.parse(localStorage.getItem('user'))
  return (item.value.memberIdx === user.memberIdx)
}

const confirmTarget=(params)=>{
  if(params.length <= 0){
    snackText.value = '선택 항목이 없습니다'
    snackbar.value = true
  }
  else {
    item.value.status = '1' //시정조치상태 1:준비 2:진행중 3:보류 4:완료
    item.value.changeType = '4' //로그에 저장 할 상태 1:생성 2:코멘트 3:상태변경 4:전달 5:코멘트삭제
    item.value.targetType = params[0].targetType //대상자 1:없음 2:부서 3:구성원
    item.value.actionYn = 'Y'
    if(params[0].targetType == '2')
      item.value.targetDeptIdx = params[0].idx
    else
      item.value.targetMemberIdx = params[0].idx
    changeStatus('')
  }
}

const confirmDelete=()=>{
  let params = {
    idx:popupIdx.value
  }

  TimelineService.deleteTimeline(params).then(
    (response) => {
      emit('delete', popupIdx.value)
      dialog.value = false
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}
</script>


<style lang="scss">
</style>
